import { FC } from 'react';
import styled from '@emotion/styled';
import formatDistanceToNow from 'date-fns/formatDistanceToNow';
import type { DTOSubscriptionBenefitItem } from 'src/apis/dto/DTOSubscription';
import { INVENTORY_ITEM_CATEGORY_ID_TYPES } from 'src/types/itemInventory';
import { languageDateLocaleMap } from 'src/utils/date';
import { getLocale } from 'src/utils/language';
const ItemContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding-block: 12px;
  background: ${({
  theme
}) => theme.color.bg2};
`;
const IconImage = styled.img<{
  isSubscriptionCategoryType: boolean;
}>`
  width: ${({
  isSubscriptionCategoryType
}) => isSubscriptionCategoryType ? '40px' : '28px'};
  height: ${({
  isSubscriptionCategoryType
}) => isSubscriptionCategoryType ? '40px' : '28px'};
  border-radius: 100px;
  object-fit: cover;
  flex-shrink: 0;
  ${({
  theme
}) => theme.isRtl && 'transform: scaleX(-1);'}
`;
const TextWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`;
const BenefitName = styled.p<{
  isSubscriptionCategoryType: boolean;
}>`
  font-size: 15px;
  font-weight: ${({
  isSubscriptionCategoryType
}) => isSubscriptionCategoryType ? 700 : 400};
  line-height: 20px;
  color: ${({
  theme
}) => theme.color.content12};
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
const DaysLeft = styled.p`
  font-size: 12px;
  font-weight: 400;
  line-height: 15px;
  color: ${({
  theme
}) => theme.color.content9};
  margin: 0;
`;
const ConsumableCount = styled.p`
  font-size: 15px;
  font-weight: 700;
  line-height: 20px;
  color: ${({
  theme
}) => theme.color.content9};
  margin: 0;
`;
const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${({
  theme
}) => theme.color.surface5};
  margin-block: 4px;
`;
interface BenefitListItemProps {
  benefit: DTOSubscriptionBenefitItem;
}

/**
 * consumable 상품의 경우, useCount와 useMins(유효기간)포함
 * periodic 상품의 경우, useMins(유효기간)만 포함
 * @see https://hpcnt.slack.com/archives/C02SQS5AJDR/p1777875171646709?thread_ts=1777864064.820349&cid=C02SQS5AJDR
 */
const BenefitListItem: FC<BenefitListItemProps> = ({
  benefit
}) => {
  const isSubscriptionCategoryType = benefit.categoryId === INVENTORY_ITEM_CATEGORY_ID_TYPES.AZAR_CORE || benefit.categoryId === INVENTORY_ITEM_CATEGORY_ID_TYPES.AZAR_MAX;
  return <>
      <ItemContainer data-sentry-element="ItemContainer" data-sentry-source-file="BenefitListItem.tsx">
        <IconImage src={benefit.iconUrl} alt={benefit.productName} isSubscriptionCategoryType={isSubscriptionCategoryType} data-sentry-element="IconImage" data-sentry-source-file="BenefitListItem.tsx" />
        <TextWrapper data-sentry-element="TextWrapper" data-sentry-source-file="BenefitListItem.tsx">
          <BenefitName isSubscriptionCategoryType={isSubscriptionCategoryType} data-sentry-element="BenefitName" data-sentry-source-file="BenefitListItem.tsx">
            {benefit.productName}
          </BenefitName>
          <DaysLeft data-sentry-element="DaysLeft" data-sentry-source-file="BenefitListItem.tsx">
            {formatDistanceToNow(new Date(Date.now() + benefit.useMins * 60 * 1000), {
            locale: languageDateLocaleMap[getLocale()]
          })}
          </DaysLeft>
        </TextWrapper>
        {benefit.type === 'consumable' && <ConsumableCount>{`x ${benefit.useCount}`}</ConsumableCount>}
      </ItemContainer>
      {isSubscriptionCategoryType && <Divider />}
    </>;
};
export default BenefitListItem;